// SPDX-License-Identifier: AGPL-3.0-or-later

export function getAppZoomFactor(): number {
	if (typeof document === 'undefined') {
		return 1;
	}
	const value = Number.parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--app-zoom-factor'));
	return Number.isFinite(value) && value > 0 ? value : 1;
}

export function appZoomLayoutPx(value: number): number {
	return value / getAppZoomFactor();
}

export function appZoomCssPx(value: number): string {
	return `${appZoomLayoutPx(value)}px`;
}
